<template>
    <span>
		<button class="btn btn-primary" @click="shownew=true" :class="additionalClasses"><b-icon icon="pencil-square"></b-icon> {{
			$t("new")
		}}</button>
		<MenuModal :show="shownew" @close="shownew = false" />
    </span>
</template>

<script>

import MenuModal from "src/components/Workflows/MenuModal.vue";
export default {
    props:{
        additionalClasses: String
    },
	components: {
		MenuModal
	},
    data() {
        return {
			shownew: false,
        }
    }
}
</script>
